const PLATFORM_TYPES = new Set(['subscription', 'hoster_subscription']);

export const getBillSourceCaption = (bill, t) => {
  const type = String(bill?.type || '').toLowerCase();
  if (PLATFORM_TYPES.has(type)) {
    return t('billSourceWaymorr');
  }
  const name = bill?.hosting_name || bill?.hoster_name || null;
  if (name) {
    return t('billSourceHoster', { name });
  }
  if (type === 'monitoring') {
    return t('billSourceWaymorr');
  }
  return t('billSourceHosterFallback');
};
